import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalculatorFrameRoutingModule } from './calculator-frame-routing.module';
import { CalculatorFrameWrapperComponent } from './calculator-frame-wrapper/calculator-frame-wrapper.component';
import { CustomerModule } from '../customer/customer.module';
import { CalculatorModule } from '../../common/components/calculator/calculator.module';
import {
  PayForFullComponent,
} from '../../common/components/solar-calculation-result/pay-for-full/pay-for-full.component';
import {
  ResultTitleComponent,
} from '../../common/components/solar-calculation-result/result-title/result-title.component';
import { SharedModule } from '../../common/shared.module';
import {
  SolarCalculatorResultModule,
} from '../../common/components/solar-calculation-result/solar-calculator-result.module';
import { TranslocoModule } from '@ngneat/transloco';
import { UserHasRolePipe } from '../../common/pipes/user-has-role.pipe';


@NgModule({
  declarations: [
    CalculatorFrameWrapperComponent,
  ],
  imports: [
    CommonModule,
    CalculatorFrameRoutingModule,
    CustomerModule,
    CalculatorModule,
    PayForFullComponent,
    ResultTitleComponent,
    SharedModule,
    SolarCalculatorResultModule,
    TranslocoModule,
    UserHasRolePipe,
  ],
})
export class CalculatorFrameModule {
}
